import * as Yup from 'yup';
import { getRequiredText } from '../../../global/helpers/transformer';

import { LabelSettingProps } from '../../../global/models/epi-model';
import { ClergyBioSettings } from '../../arc/models/arc-epi-props';
import { ClergyBioProfessionalFormModel, deleteAction } from './models/form-models';

export function GetClergyBioProfessionalValidationSchema(settings: ClergyBioSettings, labelSetting: LabelSettingProps) {

	const professionalShape = Yup.object().shape({
		role: Yup.string().when(['action'], {
			is: (a) => a !== deleteAction,
			then: Yup.string().required(getRequiredText(labelSetting.requiredFormat, settings.roleLabel)),
		}),
		title: Yup.string().when(['action'], {
			is: (a) => a !== deleteAction,
			then: Yup.string().required(getRequiredText(labelSetting.requiredFormat, settings.titleOfWorkLabel)),
		}),
	});
	const honorShape = Yup.object().shape({
		honor: Yup.string().when(['action'], {
			is: (a) => a !== deleteAction,
			then: Yup.string().required(getRequiredText(labelSetting.requiredFormat, settings.honorLabel)),
		}),
		year: Yup.string().when(['action'], {
			is: (a) => a !== deleteAction,
			then: Yup.string().required(getRequiredText(labelSetting.requiredFormat, settings.yearLabel)),
		}),
	});
	const societyShape = Yup.object().shape({
		name: Yup.string().when(['action'], {
			is: (a) => a !== deleteAction,
			then: Yup.string().required(getRequiredText(labelSetting.requiredFormat, settings.nameOfSocietyLabel)),
		}),
		startYear: Yup.string().when(['action'], {
			is: (a) => a !== deleteAction,
			then: Yup.string().required(getRequiredText(labelSetting.requiredFormat, settings.yearBeginLabel)),
		}),
	});

	return Yup.object().shape({
		publications: Yup.array()
			.of(professionalShape),
		honors: Yup.array()
			.of(honorShape),
		societies: Yup.array()
			.of(societyShape),
	});
}

export function ConstructPayload(values: ClergyBioProfessionalFormModel) {
	return {
		professionals: {
			publications: values?.publications?.filter(a => a.id || (!a?.id && a?.action !== deleteAction)).map(a => {
				return {
					role: a?.role,
					title: a?.title,
					publication: a?.publication,
					publisher: a?.publisher,
					year: a?.year,
					action: a?.action,
					id: a?.id,
				};
			}),
			honors: values?.honors?.filter(a => a.id || (!a?.id && a?.action !== deleteAction)).map(a => {
				return {
					honor: a?.honor,
					organization: a?.organization,
					year: a?.year,
					action: a?.action,
					id: a?.id,
				};
			}),
			societies: values?.societies?.filter(a => a.id || (!a?.id && a?.action !== deleteAction)).map(a => {
				return {
					name: a?.name,
					start_year: a?.startYear,
					end_year: a?.endYear,
					action: a?.action,
					id: a?.id,
				};
			}),
		},
		ecd_opt_out: values?.optOut,
	};

}

export function CreateNewProfessionalItem() {
	return {
		role: '',
		title: '',
		publication: '',
		publisher: '',
		action: '',
		year: '',
		organization: '',
		startYear: '',
		endYear: '',
	};
}